import React from 'react';
import { getHelpCenterUrl } from 'ck-utils';

const Contact = () => (
  <div className="home-section">
    <div className="container">
      <div className="section page-block--top-flush">
        <h2 className="title is-5 is-uppercase">Contact Us</h2>

        <div className="columns">
          <div className="column is-4">
            <p>
              <span className="has-text-weight-semibold">Competition Questions </span>
              competitions@culturekings.com.au <br />
              <br />
              <span className="has-text-weight-semibold">Australia</span> 1300 CKINGS (1300 254 647)<br />
              <br />
              <span className="has-text-weight-semibold">New Zealand</span> 0508 CKINGS (0508 254 647)
            </p>
          </div>
          <div className="column is-4">
            <p>
              <span className="has-text-weight-semibold">International</span> +61 7
              3345 0511 <br />
              <br />
              <span className="has-text-weight-semibold">Opening Hours</span>
              <br />
              Monday - Friday, 7am - 9pm AEST
              <br />
              Saturday - Sunday, 9am -5pm AEST
            </p>
          </div>
          <div className="column is-4">
            <div className="has-text-centered-touch">
              <a
                className="button large primary"
                href={getHelpCenterUrl()}
                rel="noopener noreferrer"
                target="_blank"
              >
                Need more Help?
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export { Contact };
